import { render, staticRenderFns } from "./TextAreaForJSON.vue?vue&type=template&id=9c7a30c8&scoped=true&"
import script from "./TextAreaForJSON.vue?vue&type=script&lang=js&"
export * from "./TextAreaForJSON.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaForJSON.vue?vue&type=style&index=0&id=9c7a30c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7a30c8",
  null
  
)

export default component.exports